import { InjectionToken } from '@angular/core'
import { TicketManagementPortalConfiguration } from './ticket-management-portal-configuration.model'

export const APP_CONFIG = new InjectionToken<TicketManagementPortalConfiguration>('TicketManagementPortalConfiguration');
export const ApplicationConfiguration: TicketManagementPortalConfiguration = {
    flow: 'relocation',
    endDate: null,
    assets: {
        logoUrl: '../../assets/img/logo.png',
        bgUrl: ''
    },
    purchaseLink: null,
    guide: {
        mobileSteps: 0,
        desktopSteps: 0,
        guideUrl: ''
    },
    topbar: {
        includeInfoIcon: true,
        includeSwitchTheme: false
    },
    colors: {
        main: '',
        accent: '',
        glow: '',
        textAddon: '',
        mapElement: {
            available: '',
            selected: '',
            pending: ''
        }
    },
    dvmConfiguration: {
        venue_id: '',
        map_id: '',
        version: 'development'
    },
    generalAdmissionAreas: [],
    rules: {
        allowUpgrades: false,
        limitCheckoutBalance: false,
        limitCheckoutSeats: false,
        preventIsolatedSeats: true,
        selectSeatsInGroupsOf: 1,
        allowPaymentMethods: false,
        redirectUrl: '',
        areaNeighborsNavigation: false,
        transactionTimerLimit: 5,
        defaultPaymentMethod: 'full',
        showPayInFull: true,
        showPaymentPlan: true,
        hasParking: false,
        parkingMaxSlots: 0,
        isTaxesBreakdownEnabled: false,
        showAddDigitalWalletButton: false
    },
    modals:{
      warmWelcome: false
    },
    footer: {
        copyrightText: '2025 3D Digital Venue by Mobile Media Content (MMC).'
    },
    text: {
        title: '',
        subtitle: '',
        salesRep: {
            title: ''
        },
        landing: {
            plansTitle: '',
            plansNoSeatsTitle: ''
        },
        planElement: {
            processAvailable: '',
            processStart: '',
            seatsTitle: '',
            noSeatsText: '',
            disclamerText: ''
        },
        subInterface: {
            upgradePlanText: '',
            noUpgradePlanText: '',
            noUpgradeAddons: '',
            infoTextSeatselection: ''
        },
        checkout: {
            digitalWalletChargeText: '',
            digitalWalletFallbackNoticeText: '',
            installmentCreditCardDisclaimerText: '',
            installmentCreditCardText: '',
            preLegalText: '',
            legalText: '',
            newSeatsText: '',
            totalBalance: '',
            previousSeatsText: '',
            alreadyPaid: '',
            refundText: '',
            selectDigitalWalletText: '',
            setUpPaymentPlanText: ''
        },
        bottom: {
            tooltip: ''
        },
        summary: {
            headerText: '',
            legalText: ''
        },
        modals: {
            checkoutModal: '',
            congratulationsModal: '',
            restartProgressModal: '',
            checkout2ConfirmationModal: '',
            welcomeModal: '',
            welcomeModalTitle: '',
            requiresSignatureModal: ''
        },
        processDisabledText: {
            title: '',
            text: ''
        },
        legendMapText: {
            ownedSeats: ''
        }
    }
};
